import { API_ROUTES } from 'lib/api-routes';
import { TSearchList, TSearchListRequest } from 'lib/models/search-page';
import { apiInstance } from 'lib/utils/axios';

export async function addCandidateSearchList({ searchList }: { searchList: TSearchListRequest }) {
  return await apiInstance.post<TSearchList>(API_ROUTES.CANDIDATE_SEARCH_LISTS, searchList);
}

export async function deleteCandidateSearchList({ listId }: { listId: string }) {
  return await apiInstance.delete(`${API_ROUTES.CANDIDATE_SEARCH_LISTS}/${listId}`);
}

export async function updateCandidateSearchList(listId: string, data: Partial<TSearchListRequest>) {
  return await apiInstance.put<TSearchList>(`${API_ROUTES.CANDIDATE_SEARCH_LISTS}/${listId}`, data);
}
